'use strict';

var _ = require('lodash');

var StoreFactory = function ($injector, $rootScope, EventUtil) {
  
  // list of registered stores
  var stores = {};

  /**
   * @extends EventEmitter
   */
  function Store (definition) {

    Store.checkRequired(definition);

    this.$name = definition.name;
    this.$state = _.extend({}, _.clone(definition.state, true));
    this.Events = {};
    
    this._initEvents(definition.events);

    // If defined, call the init method
    if (this.init && typeof this.init === 'function') {
      this.init.apply(this, arguments);
    }

    EventUtil.EventEmitter.call(this);
  }

  //////////////////////////////////////////////////////////////////////////////
  // Static Properties
  //////////////////////////////////////////////////////////////////////////////

  Store.Required = ['name'];
  
  Store.checkRequired = function (params) {
    _.forEach(Store.Required, function (key) {
      if (params[key] === undefined) {
        throw new Error('Missing required parameter ' + key);
      }
    });
  };

  Store.get = function (name) {
    return stores[name];
  };

  Store.create = function (definition) {
    var store = stores[definition.name];

    if (!store) {
      var inst = Object.create(this.prototype);
      var obj = this.apply(inst, arguments);

      store = Object(obj) === obj ? obj : inst;
      stores[definition.name] = store;
    }

    return store;
  };

  Store.extend = function (protoProps, staticProps) {
    var parent = this;
    var child;

    // Setup the child constructor
    if (protoProps && _.has(protoProps, 'constructor')) {
      child = protoProps.constructor;
    } else {
      child = function () {
        return parent.apply(this, arguments);
      };
    }

    _.extend(child, parent, staticProps);

    var Surrogate = function () {
      this.constructor = child;
    };

    Surrogate.prototype = parent.prototype;
    child.prototype = new Surrogate();

    if (protoProps) {
      if (_.isArray(protoProps)) {
        _.extend.apply(null, [child.prototype].concat(protoProps));
      } else {
        _.extend(child.prototype, protoProps);
      }
    }

    child.__super__ = parent.prototype;
    return child;
  };

  //////////////////////////////////////////////////////////////////////////////
  // Prototype Properties
  //////////////////////////////////////////////////////////////////////////////

  Store.prototype = Object.create(EventUtil.EventEmitter.prototype);
  Store.prototype.constructor = Store;

  Store.prototype.$set = function (key, val) {
    var store = this;
    store.$state[key] = val;
  };

  /**
   * Retrieve a specific state value. If the value is an object it will always
   * return a copy to prevent unexpected bugs where the object in memory is modified
   * before the actual event to change the state has executed.
   * 
   * @param  {[type]} key [description]
   * @return {[type]}     [description]
   */
  Store.prototype.get = function (key, clone) {
    var val = this.$state[key];
    clone = !_.isUndefined(clone) ? clone : true;
    if (typeof val === 'object' && clone) {
      return _.clone(val);
    } else {
      return val;
    }
  };

  Store.prototype.getAll = function () {
    return _.clone(this.$state);
  };

  Store.prototype._initEvents = function (events) {
    // Use event keys as the eventname unless specified
    _.forEach(events, function (val, key) {
      if (typeof value !== 'string') {
        this.Events[key] = key;
      } else {
        this.Events[key] = val;
      }
    }.bind(this));
  };

  /**
   * Convenience method used to watch a specific value of a store state and either
   * execute a callback or broadcast an event if the value has changed. Unlike
   * 
   * @param  {String} key Store state to watch
   * @param  {Function|String} handler Eventname or function to execute
   * @param {String} type watch type, default to equality
   */
  Store.prototype.watch = function (key, handler, type) {
    var store = this;
    var watcher = $rootScope.$watch.bind($rootScope);

    if (type === 'collection') {
      watcher = $rootScope.$watchCollection.bind($rootScope);
    } else if (type === 'group') {
      watcher = $rootScope.$watchGroup.bind($rootScope);
    }
    
    watcher(this._getWatchFn(key), function (val, oldval) {
      if (typeof handler === 'function') {
        handler(val, oldval);
      } else if (typeof handler === 'string') {
        store.emit(handler); // broadcast the event
      }
    });
  };

  Store.prototype._getWatchFn = function (key) {
    var store = this;
    return function () {
      return store.get(key, false);
    };
  };

  return Store;
};

StoreFactory.$inject = ['$injector', '$rootScope', 'sbFluxEvent'];
module.exports = StoreFactory;


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/flux/src/lib/Store.js